<div class="top">
    <button type="button" [attr.aria-label]="'MENU.PRIVATE_CORPRATE_TOGGLE'| translate:{status:selectedMarketSegmentDiff}" (click)="toggleMarketSegment()">
        @for (segment of marketSegments; track $index) {
            @if($index > 0) {
                <span>/</span>
            }
            <span class="market-segment" [attr.selected]="segment==selectedMarketSegment ? '' : null">{{ 'MARKET_SEGMENT.'+segment+'_VAT_SIMPLE' | uppercase | translate  }}</span>
        }
    </button>
    <a [href]="'tel:'+menu.store.phone"
       *ngIf="menu?.store?.phone != null">{{ 'MENU.PHONE' | translate: {phone:menu.store.phone} }}</a>
</div>
<div class="main">
    <button class="main-menu"
            type="button"
            [attr.aria-label]="'MENU.MENU' | translate"
            (click)="headerMenu.openMobileMenu()">
        <app-svg use="menu"></app-svg>
    </button>
    <a class="logo"
       [attr.aria-label]="'MENU.LOGO_LABEL' | translate"
       [href]="'/'">
       @if(logoUrl.href.endsWith('.svg')) {
           <app-svg [use]="logoUrl.href"></app-svg>
        } @else {
            <img class="logo-image"
            [use]="logoUrl"
            role="presentation"
            auto="width"
            [srcset]="[ { srcset: mobileLogoUrl, media: '(max-width: 768px)' }, { srcset: logoUrl, media: '(min-width: 769px)' } ]" />
        }
    </a>
    <app-header-search></app-header-search>
    <app-header-basket-button></app-header-basket-button>
</div>
<app-header-menu #headerMenu></app-header-menu>

<!-- <button class="action menu"
            role="menuitem"
            [attr.aria-label]="'MENU.MENU' | translate"
            [class.show]="selected | hasNestedMenu"
            (click)="openOverlayMenu()">
        <app-svg class="action-icon"
                 use="menu"></app-svg>
    </button> -->
<!-- <div role="presentation">
        <ng-container *ngTemplateOutlet="menuLinks; context:{$implicit:menu?.productMenu, selected}"></ng-container>
    </div>
    <div role="presentation">
        <ng-container *ngTemplateOutlet="menuLinks; context:{$implicit:menu?.contentMenu, selected}"></ng-container>
    </div>
    <ng-container *ngTemplateOutlet="actionLinks; context:{$implicit:actions}"></ng-container> -->
<!-- <ng-container *ngIf="menu | menuToCta as cta">
    <ng-template #noLinkTemplate>
        <span class="call-to-action"
              [style.color]="cta?.color"
              [style.background-color]="cta?.backgroundColor"
              [style.background-image]="cta?.backgroundImage != null ? 'url('+(cta?.backgroundImage | imageQuery:{})+')': null"
              [style.font-family]="cta?.fontFamily"
              [innerHTML]="cta?.text"></span>
    </ng-template>
    <a class="call-to-action"
       [routerLink]="cta.link"
       [style.color]="cta?.color"
       [style.background-color]="cta?.backgroundColor"
       [style.background-image]="cta?.backgroundImage != null ? 'url('+(cta?.backgroundImage | imageQuery:{})+')': null"
       [style.font-family]="cta?.fontFamily"
       [innerHTML]="cta?.text"
       *ngIf="cta?.link != null && cta?.link !== ''; else noLinkTemplate"></a>
</ng-container>
<ng-template #overlayDropdown
             let-links
             let-offsetTop="offsetTop">
    <app-overlay-dropdown [menu]="links"
                          [style.top.px]="offsetTop"></app-overlay-dropdown>
</ng-template>
<ng-template #overlayMenu>
    <app-overlay-menu></app-overlay-menu>
</ng-template>
<ng-template #overlayBasket>
    <app-overlay-basket></app-overlay-basket>
</ng-template>
<ng-template #overlayLanguage>
    <app-overlay-languages></app-overlay-languages>
</ng-template>
<ng-template #overlaySearch
             let-offsetTop="offsetTop">
    <app-overlay-search [style.top.px]="offsetTop"></app-overlay-search>
</ng-template>
<ng-template #actionLinks
             let-actions>
    <ng-container *ngFor="let action of actions">
        <ng-container *ngTemplateOutlet="action?.function==null?actionLink:actionButton;context:{$implicit:action}"></ng-container>
    </ng-container>
</ng-template>
<ng-template #menuLinks
             let-links
             let-selected="selected">
    <ng-container *ngFor="let link of links">
        <ng-container *ngTemplateOutlet="link?.children?.length > 0 ? menuButton:menuLink;context:{$implicit:link, selected}"></ng-container>
    </ng-container>
</ng-template>
<ng-template #actionButton
             let-action>
    <button class="action-button"
            role="menuitem"
            [attr.aria-label]="action?.title"
            (click)="action?.function()">
        <app-svg aria-hidden="true"
                 [use]="action?.image"
                 [attr.count]="action?.count | async"
                 *ngIf="!action?.image?.focalPoint"></app-svg>
        <img aria-hidden="true"
             [use]="action?.image"
             [query]="{width: 48, height:48, }"
             [attr.count]="action?.count | async"
             *ngIf="action?.image?.focalPoint">
        <span class="action-text"
              aria-hidden="true"
              *ngIf="action?.hideTitle">{{ action?.title }}</span>
    </button>
</ng-template>
<ng-template #actionLink
             let-action>
    <a class="action-link"
       role="menuitem"
       [attr.aria-label]="action?.title"
       [routerLink]="action?.link">
        <app-svg aria-hidden="true"
                 [use]="action?.image"
                 [attr.count]="action?.count | async"
                 *ngIf="!action?.image?.focalPoint"></app-svg>
        <img aria-hidden="true"
             [use]="action?.image"
             [query]="{width: 48, height:48, }"
             [attr.count]="action?.count | async"
             *ngIf="action?.image?.focalPoint">
        <span class="action-text"
              aria-hidden="true"
              *ngIf="action?.hideTitle">{{ action?.title }}</span>
    </a>
</ng-template>
<ng-template #menuButton
             let-selected="selected"
             let-link>
    <button class="menu-button"
            role="menuitem"
            [title]="link?.title"
            [class.selected]="selected===link"
            (click)="openDropdown(link)">{{link?.title}}</button>
</ng-template>
<ng-template #menuLink
             let-selected="selected"
             let-link>
    <a class="menu-link"
       role="menuitem"
       [title]="link?.title"
       [class.selected]="selected===link"
       [routerLink]="link?.link">{{link?.title}}</a>
</ng-template> -->
